import { AsistenteEnLineaUtils } from './../../utils/asistente-en-linea.utils';
import { HandlerType } from './../../models/HandlerType';
import { Component, OnInit, Input, Output, EventEmitter, HostListener, OnDestroy } from '@angular/core';
import { LocalStorageService } from '../../services/local-storage.service';


@Component({
  selector: 'app-asistencia-menu',
  templateUrl: './asistencia-menu.component.html',
  styleUrls: ['./asistencia-menu.component.css']
})

export class AsistenciaMenuComponent implements OnInit, OnDestroy {
  @Input() handlerType: HandlerType;
  // chat - 0, email - 1, menu - 2, arbol - 3
  @Output() renderComponent = new EventEmitter<boolean[]>();

  constructor(private localstorage: LocalStorageService,
    private util: AsistenteEnLineaUtils) {

  }

  ngOnInit() {
  }

  onClickRenderComponent(component: string) {
    if (component === 'chat') {
      // chat - 0, email - 1, menu - 2, arbol - 3
      this.renderComponent.emit(this.util.renderChat);
    }
    else {
      if (component === 'menuArbol') {
        this.renderComponent.emit(this.util.renderMenuArbol);
      } else {
        // chat - 0, email - 1, menu - 2, arbol - 3
        this.renderComponent.emit(this.util.renderEmail);
      }

    }
  }


  ngOnDestroy() {
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event: Event) {
  }

  @HostListener('window:unload', ['$event'])
  unloadHandler(event: Event) {
  }
}
